@use 'variables' as *;
@use 'mixins' as *;
@use 'sass:map';

:host {
  display: flex;
  gap: 0.5rem;
  padding: 1.25rem;
  border-radius: cat-border-radius('l');
}

:host([hidden]) {
  display: none;
}

:host(:focus-visible) {
  outline: 2px solid cat-token('color.ui.border.focus');
  outline-offset: 1px;
}

.content {
  align-self: center;
  width: 100%;
}

::slotted(:last-child) {
  margin-bottom: 0 !important;
}

// ----- theme

@mixin theme($theme) {
  :host([color='#{$theme}']) {
    background-color: cat-token('color.theme.#{$theme}.bg');
    color: cat-token('color.theme.#{$theme}.fill');
    // adjust nested links
    --cat-primary-text: #{cat-token('color.theme.#{$theme}.fill', $wrap: false)};
    --cat-primary-text-hover: #{cat-token('color.theme.#{$theme}.fillHover', $wrap: false)};
    --cat-primary-text-active: #{cat-token('color.theme.#{$theme}.fillActive', $wrap: false)};
    --cat-link-decoration: underline;
  }
}

@include theme('primary');
@include theme('secondary');
@include theme('info');
@include theme('success');
@include theme('warning');
@include theme('danger');
